import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { types } from '../../../../utils/config/widgetsConfig';

export const buildObj = (foundObj, item, child, parent, returnOptions, configValues, selectedPeriodicity) => {
    var key = foundObj[0];
    var value = foundObj[1];
    return {
        ...item,
        key: key,
        value: value,
        fieldTypeOf: item.fieldTypeId ? types.get(item.fieldTypeId) : types.get(2),
        required: item?.required ?? false,
        options: returnOptions(key, configValues, selectedPeriodicity),
        size: item?.size ?? null,
        name: item?.title ?? null,
        description: item?.description ?? null,
        child: child,
        parent: parent,
        customObject: item?.customObject ?? null,
        isVisible: item.isVisible ?? true,
        rule: item?.rule ?? null,
        validateRule: item?.validateRule ?? null,
        btnFunction: item?.btnFunction ?? null,
        text: item?.text ?? null,
        align: item?.align ?? "left",
        listData: item?.listData ?? null,
        tableConfig: item?.tableConfig ?? null,
        allowedToWrite: item?.allowedToWrite ?? false,
        toEdit: item?.toEdit ?? false,
        handleEdit: item?.handleEdit ?? (() => { }),
        toDelete: item?.toDelete ?? false,
        handleDelete: item?.handleDelete ?? (() => { }),
        hasCheckbox: item?.hasCheckbox ?? null,
        onRowSelect: item?.onRowSelect ?? (() => { }),
        switchFn: item?.switchFn ?? (() => { }),
        checked: item?.checked ?? <CheckOutlined />,
        unChecked: item?.unChecked ?? <CloseOutlined />,
        disabled: item?.disabled ?? false,
    };
};

/**
 * Returns an array of customized buttons for configuration based on the given parameters.
 *
 * @param {boolean} allowedToWrite - Indicates whether the user is allowed to write.
 * @param {function} onClick - The function to be called when the button is clicked.
 * @param {function} t - The translation function.
 * @returns {Array} - An array of customized buttons for configuration.
 */
export const getCustomizedButtonsForConfiguration = (allowedToWrite, onClick, t) => {
    return allowedToWrite ? [{
        title: t('create'),
        function: onClick,
        type: "-blue"
    }] : [];
}